/*
  Merch product page behavior (sections/merch-product.liquid).
  Progressive enhancement: without JS the form still posts the selected
  default variant to /cart/add. With JS it handles option picking, the
  gallery, the sauce add-on (added in the same request), and the mobile
  sticky add-to-cart bar.
*/
(function () {
  'use strict';

  // Store sells in USD only; matches Liquid's `money` output ($24.99).
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function init(root) {
    if (root.__jmReady) return;
    root.__jmReady = true;

    var variantsEl = root.querySelector('[data-jm-variants]');
    var variants = [];
    try { variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]'); } catch (e) { variants = []; }

    var form = root.querySelector('[data-jm-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-jm-variant-id]');
    var qtyInput = form.querySelector('[data-jm-qty-input]');
    var addon = form.querySelector('[data-jm-addon]');
    var atc = form.querySelector('[data-jm-atc]');
    var atcLabel = form.querySelector('[data-jm-atc-label]');
    var priceEl = root.querySelector('[data-jm-price]');
    var compareEl = root.querySelector('[data-jm-compare]');
    var errorEl = form.querySelector('[data-jm-error]');
    var sticky = root.querySelector('[data-jm-sticky]');
    var stickyBtn = root.querySelector('[data-jm-sticky-btn]');
    var stickyLabel = root.querySelector('[data-jm-sticky-label]');
    var stickyVariant = root.querySelector('[data-jm-sticky-variant]');
    var optionInputs = Array.prototype.slice.call(form.querySelectorAll('[data-jm-option]'));

    var current = null;
    var idNow = parseInt(idInput.value, 10);
    for (var i = 0; i < variants.length; i++) { if (variants[i].id === idNow) current = variants[i]; }

    /* ---------- Gallery ---------- */
    var imgs = Array.prototype.slice.call(root.querySelectorAll('.jm-gallery__img'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb-for]'));
    function showMedia(id) {
      if (!id) return;
      var found = false;
      imgs.forEach(function (img) {
        if (String(img.getAttribute('data-media-id')) === String(id)) found = true;
      });
      if (!found) return;
      imgs.forEach(function (img) {
        img.classList.toggle('is-active', String(img.getAttribute('data-media-id')) === String(id));
      });
      thumbs.forEach(function (t) {
        var on = String(t.getAttribute('data-thumb-for')) === String(id);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb-for')); });
    });

    /* ---------- Options -> variant ---------- */
    function selectedOptions() {
      var picked = [];
      optionInputs.forEach(function (input) {
        if (input.checked) picked[parseInt(input.getAttribute('data-jm-option'), 10)] = input.value;
      });
      return picked;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var j = 0; j < v.options.length; j++) {
          if (opts[j] !== undefined && v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function markAvailability(opts) {
      optionInputs.forEach(function (input) {
        if (input.type !== 'radio' || !input.id) return;
        var idx = parseInt(input.getAttribute('data-jm-option'), 10);
        var test = opts.slice();
        test[idx] = input.value;
        var ok = variants.some(function (v) {
          if (!v.available) return false;
          for (var j = 0; j < v.options.length; j++) {
            if (test[j] !== undefined && v.options[j] !== test[j]) return false;
          }
          return true;
        });
        var label = form.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !ok);
      });
    }

    function render() {
      var available = current && current.available;
      var total = current ? current.price * Math.max(1, parseInt(qtyInput.value, 10) || 1) : 0;
      if (addon && addon.checked) total += parseInt(addon.getAttribute('data-price'), 10) || 0;

      if (current) {
        idInput.value = current.id;
        if (priceEl) priceEl.textContent = money(current.price);
        if (compareEl) {
          if (current.compare > current.price) { compareEl.textContent = money(current.compare); compareEl.hidden = false; }
          else { compareEl.hidden = true; }
        }
        if (stickyVariant && variants.length > 1) stickyVariant.textContent = current.title;
      }
      atc.disabled = !available;
      atcLabel.textContent = !current ? 'Unavailable' : (available ? 'Add to cart · ' + money(total) : 'Sold out');
      if (stickyBtn) {
        stickyBtn.disabled = !available;
        stickyLabel.textContent = !current ? 'Unavailable' : (available ? 'Add · ' + money(total) : 'Sold out');
      }
    }

    function onOptionChange() {
      var opts = selectedOptions();
      current = findVariant(opts);
      opts.forEach(function (val, idx) {
        var lab = root.querySelector('[data-jm-option-label="' + idx + '"]');
        if (lab) lab.textContent = val;
      });
      markAvailability(opts);
      if (current && current.media) showMedia(current.media);
      if (current && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', current.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
      render();
    }

    optionInputs.forEach(function (input) { input.addEventListener('change', onOptionChange); });
    markAvailability(selectedOptions());

    /* ---------- Quantity ---------- */
    Array.prototype.slice.call(form.querySelectorAll('[data-jm-qty]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.getAttribute('data-jm-qty'), 10);
        qtyInput.value = Math.min(20, Math.max(1, n));
        render();
      });
    });
    qtyInput.addEventListener('change', function () {
      qtyInput.value = Math.min(20, Math.max(1, parseInt(qtyInput.value, 10) || 1));
      render();
    });
    if (addon) addon.addEventListener('change', render);

    /* ---------- Add to cart (merch + optional bundle in one request) ---------- */
    var busy = false;
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !current) return; // fall back to a normal form post
      e.preventDefault();
      if (busy || !current.available) return;
      busy = true;
      atc.disabled = true;
      if (errorEl) errorEl.hidden = true;

      var items = [{ id: current.id, quantity: Math.max(1, parseInt(qtyInput.value, 10) || 1) }];
      if (addon && addon.checked) {
        items.push({ id: parseInt(addon.value, 10), quantity: 1, properties: { _source: 'merch-addon' } });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      }).then(function (r) {
        if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || 'Could not add to cart.');
        window.location.href = '/cart';
      }).catch(function (err) {
        busy = false;
        render();
        if (errorEl) { errorEl.textContent = err.message || 'Something went wrong. Please try again.'; errorEl.hidden = false; }
      });
    });

    /* ---------- Mobile sticky bar ---------- */
    if (sticky && stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else atc.click();
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var below = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', below);
            sticky.setAttribute('aria-hidden', below ? 'false' : 'true');
            stickyBtn.tabIndex = below ? 0 : -1;
          });
        });
        io.observe(atc);
      }
    }

    render();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-jm-root]')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // The theme uses InstantClick page swaps: re-run after each swap.
  if (window.InstantClick && typeof window.InstantClick.on === 'function') {
    try { window.InstantClick.on('change', boot); } catch (e) {}
  }
})();
